import {
  getHireJobsApplicantsFunnelCountsRetrieveQueryOptions,
  getHireJobsApplicantsListInfiniteQueryOptions,
  getNextPageParam,
  getPreviousPageParam,
} from "@sidegigllc/api/client";
import { queries as applicantSheetQueries } from "domains/hire/containers/ApplicantSheetContainer/queries";
import { queries as convertShiftsQueries } from "domains/hire/containers/ConvertShiftsButton/queries";
import { jobStatusCountsQuery } from "domains/hire/containers/JobList/queries";
import { queries as workingInterviewsQueries } from "domains/hire/containers/WorkingInterviewsPanel/queries";
import type { ApplicantSearch } from "routing/tree/hire";
import type { WarmableQuery } from "routing/warmQueries";
import { toApplicantListParams } from "./listParams";

type QueriesInput = {
  jobId: string;
  locationId: number;
  search: ApplicantSearch;
  locked: boolean | undefined;
  /** Applied tab with hire-offer-moments on: true lists only known pros (the pinned section), false only the rest. */
  workedWithYou?: boolean;
};

export const funnelCountsQuery = ({ jobId, search, locked }: QueriesInput) => {
  const {
    ordering: _ordering,
    funnel_stage: _funnelStage,
    applicant_id: _applicantId,
    offerType: _offerType,
    favorites,
    employment_types,
    ...candidateFilters
  } = search;
  return getHireJobsApplicantsFunnelCountsRetrieveQueryOptions(
    jobId,
    { ...candidateFilters, employment_types: employment_types?.join(","), is_preferred: favorites },
    { query: { enabled: locked === false } },
  );
};

export const applicantsQuery = ({ jobId, search, locked, workedWithYou }: QueriesInput) =>
  getHireJobsApplicantsListInfiniteQueryOptions(
    jobId,
    { ...toApplicantListParams(search, search.funnel_stage ?? "applied"), worked_with_you: workedWithYou },
    {
      query: { getNextPageParam, getPreviousPageParam, enabled: locked === false },
    },
  );

export const invitedApplicantsQuery = (input: QueriesInput, enabled: boolean) =>
  getHireJobsApplicantsListInfiniteQueryOptions(input.jobId, toApplicantListParams(input.search, "invited"), {
    query: { getNextPageParam, getPreviousPageParam, enabled: enabled && input.locked === false },
  });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  jobStatusCountsQuery(),
  funnelCountsQuery(input),
  applicantsQuery(input),
  ...workingInterviewsQueries(),
  ...convertShiftsQueries(),
  ...applicantSheetQueries({ ...input, applicantId: input.locked ? undefined : input.search.applicant_id }),
];
